import { useEffect, useRef, useState } from "react";
import authService from "../../Auth/AuthService";
import SalarySlip from "../../reciept/SalarySlip";
import { Box, Button, MenuItem, TextField } from "@mui/material";
import { DownloadIcon, PrinterIcon } from "lucide-react";
import { Search } from "@mui/icons-material";
import { downloadSalaryPDF } from "../../others/SalarySlipPDF";
import { useLocation, useNavigate } from "react-router-dom";

const months = [
    { label: "January", value: "January" },
    { label: "February", value: "February" },
    { label: "March", value: "March" },
    { label: "April", value: "April" },
    { label: "May", value: "May" },
    { label: "June", value: "June" },
    { label: "July", value: "July" },
    { label: "August", value: "August" },
    { label: "September", value: "September" },
    { label: "October", value: "October" },
    { label: "November", value: "November" },
    { label: "December", value: "December" }
];
const BulkSalarySlip = () => {
    const [employees, setEmployees] = useState([]);
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().toLocaleString('en-US', { month: 'long' });
    const [month, setMonth] = useState(currentMonth);
    const [year, setYear] = useState(currentYear);
    const hasFetched = useRef(false);
    const [show, setShow] = useState(true);
    const years = Array.from({ length: 3 }, (_, i) => currentYear - i);
    const location = useLocation().state;
    const empIds = location.empIds;
    const navigate = useNavigate();
    const [school, setSchool] = useState({});
    const DOC_URL = authService.DOC_URL

    useEffect(() => {
        if (hasFetched.current) return;
        hasFetched.current = true;
        loadSalarySlip();
        loadSchool();
    }, []);

    const loadSchool = async () => {
        try {
            const url = authService.pathUrl("GET", "/schools/email");
            const schoolsData = await authService.getAuth(url);
            const updatedForm = {
                ...schoolsData,
                logoUrl: DOC_URL + schoolsData.logoUrl
            };
            setSchool(updatedForm);

        } catch (error) {
            console.error("Error fetching schools:", error);
        }
    }

    const loadSalarySlip = async () => {
        try {
            const url = authService.pathUrl('GET', '/salary/slip/bulk?empIds=' + `${empIds}` + '&month=' + `${month}` + '&year=' + `${year}`);
            const data = await authService.getAuth(url);
            setEmployees(data.map(d => ({
                ...d,
                photo: d.photo ? DOC_URL + d.photo : null
            })));
        } catch (error) {
            console.error("Error fetching schools:", error);
        }
    };

    return (

        <Box marginTop={2}>
            {show && (
                <Box display="flex" justifyContent={'center'} gap={2} mb={2}>
                    <Button onClick={() => navigate(-1)} sx={{ bgcolor: '#1b1914', color: '#fff' }}>Back</Button>
                    <TextField
                        select
                        size="small"
                        label="Month"
                        value={month}
                        onChange={e => setMonth(e.target.value)}
                    >
                        {months.map(m => (
                            <MenuItem key={m.value} value={m.value}>
                                {m.label}
                            </MenuItem>
                        ))}
                    </TextField>

                    <TextField
                        select
                        label="Year"
                        size="small"
                        value={year}
                        onChange={e => setYear(Number(e.target.value))}
                    >
                        {years.map(y => (
                            <MenuItem key={y} value={y}>
                                {y}
                            </MenuItem>
                        ))}
                    </TextField>

                    <Button onClick={() => loadSalarySlip()}><Search /></Button>

                    <Button
                        variant="contained" sx={{ bgcolor: '#1b1914' }}
                        onClick={() => {
                            setShow(false);
                            setTimeout(() => {
                                window.print();
                                setShow(true);
                            }, 100);
                        }}><PrinterIcon /> print</Button>
                    <Button
                        variant="contained" sx={{ bgcolor: '#1b1914' }}
                        onClick={() =>
                            downloadSalaryPDF("salary-slip", "SalarySlip.pdf")
                        }
                    >
                        <DownloadIcon fontSize="large" />pdf
                    </Button>
                </Box>
            )}

            <Box id="salary-slip">
                {employees?.map((emp, idx) => (
                    <div key={idx} style={{ pageBreakAfter: "always" }}>
                        <SalarySlip data={{ ...emp, ...school }} />
                    </div>
                ))}

            </Box>
        </Box>
    );
};

export default BulkSalarySlip;
